module.exports = __webpack_public_path__ + "img/App.aa5e6b33.png";